// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1MHs-","large":"styles_large__2r8l6"};